const ReloadSitePlugin = {
  install (Vue) {
    Vue.reloadSiteTumbleQuery = () => {
      const url = new URL(window.location.href)
      url.searchParams.set('reload-url-qoken', `${Date.now()}`)
      window.location.href = url.toString()
    }
  }
}

export default ReloadSitePlugin
